import { ref } from 'vue'

const packagePriceId = ref(null)

const setState = (newPackagePriceId) =>
  (packagePriceId.value = newPackagePriceId)

const clearState = () => {
  packagePriceId.value = null
}

export { packagePriceId, setState, clearState }
